// Additional Collection — hub + sub-pages (placeholders)
import { IMG, ASSETS } from "@/lib/site";
import { WOOD_TONES } from "@/lib/timber";

const LEAD =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua — specialist finishes, considered and made to order.";

const pick = (n, offset = 0) =>
  Array.from({ length: n }).map((_, i) => WOOD_TONES[(i + offset) % WOOD_TONES.length]);

export const ADDITIONAL_HUB = {
  eyebrow: "Our Collection / 04",
  title: "Additional Collection",
  hero: IMG.microcement,
  intro:
    "Specialist finishes and joinery that complete an interior — seamless plasterwork, decorative wall systems and made-to-order solid timber doors, applied and crafted by skilled hands.",
  categories: [
    {
      label: "Artisan Plastering",
      to: "/collections/additional/artisan-plastering",
      image: IMG.microcement,
      caption: "Seamless lime & micro cement",
    },
    {
      label: "Kingdom Wall Panels",
      to: "/collections/additional/kingdom-wall-panels",
      image: ASSETS.slatWall,
      caption: "Decorative wall systems",
    },
    {
      label: "Custom Doors",
      to: "/collections/additional/custom-doors",
      image: IMG.oakDoor,
      caption: "Made-to-order solid timber",
    },
  ],
};

export const ADDITIONAL = {
  "artisan-plastering": {
    name: "Artisan Plastering",
    hero: IMG.microcement,
    intro: LEAD,
    sizes: ["Trowel-applied · 2–3 mm", "Polished · 1–2 mm"],
    swatchLabel: "Colour Selection",
    colours: pick(5, 0),
  },
  "kingdom-wall-panels": {
    name: "Kingdom Wall Panels",
    hero: ASSETS.slatWall,
    intro: LEAD,
    sizes: ["2400 × 600 mm", "2700 × 600 mm", "3000 × 600 mm"],
    swatchLabel: "Finish Selection",
    colours: pick(5, 6),
  },
  "custom-doors": {
    name: "Custom Doors",
    hero: IMG.oakDoor,
    intro: LEAD,
    sizes: ["2040 × 820 mm", "2340 × 920 mm", "Custom size"],
    swatchLabel: "Timber & Finish",
    colours: pick(5, 12),
  },
};

export const ADDITIONAL_ORDER = ["artisan-plastering", "kingdom-wall-panels", "custom-doors"];
